import React, { createContext, useState, useMemo, useEffect } from "react";
import { DragDropContext } from "react-beautiful-dnd"

export const DragAndDropContext = createContext(null);

export const DragDropContextProvider = ({ children }) => {
    const [oDragResult, fnSetODragResult] = useState(null)
    const [bIsOpenBlocks, fnSetBIsOpenBlocks] = useState(false)
    const [oOnDragEnd, fnSetOonDragEnd] = useState(null)
    const [oOnDragStart, fnSetOonDragStart] = useState(null)
    const [oOnDragUpdate, fnSetOonDragUpdate] = useState(null)

    function onDragEnd(e) {
        fnSetBIsOpenBlocks(true)
        fnSetODragResult(e)
        fnSetOonDragStart(null)
    }
    function onDragStart(e) {
        fnSetOonDragStart(e)
        return e
    }
    function onBeforeDragStart(e) {
        fnSetBIsOpenBlocks(false)
        fnSetODragResult(e)

        return e
    }

    const value = useMemo(() => {
        return { oDragResult, bIsOpenBlocks, fnSetBIsOpenBlocks, fnSetODragResult, oOnDragStart, oOnDragUpdate };
    }, [oDragResult, bIsOpenBlocks, oOnDragEnd, oOnDragStart, oOnDragUpdate])

    return (
        <DragAndDropContext.Provider value={value}>
            <DragDropContext onDragEnd={onDragEnd} onBeforeDragStart={onBeforeDragStart} onDragUpdate={(e) => fnSetOonDragUpdate(e)} onDragStart={onDragStart}>
                {children}
            </DragDropContext>
        </DragAndDropContext.Provider>
    );
};

export default DragAndDropContext;